// Paddle uses 'month' / 'year'; Stripe used 'monthly' / 'yearly' / 'annual'.
// Both still exist in the account table — accept all forms, normalize to UI.
export const formatBilling = (interval: string | null | undefined): string => {
  if (!interval) return '-';
  const lower = interval.toLowerCase();
  if (lower === 'month' || lower === 'monthly') return 'Monthly';
  if (lower === 'year' || lower === 'yearly' || lower === 'annual') return 'Annual';
  return interval;
};
